import React from "react";
import { accountStatusLabel, isPaidAccount } from "../../../lib/accountStatus";

import { useTranslation } from "../../../i18n";

const AccountStatusBadge = ({ status, className = "" }) => {
  const { t } = useTranslation();
  const paid = isPaidAccount(status);

  return (
    <span
      className={[
        "inline-flex items-center gap-2 rounded-full px-3.5 py-1.5 text-[13px] font-semibold ring-1 ring-inset",
        paid
          ? "bg-emerald-50 text-emerald-800 ring-emerald-200"
          : "bg-[#f1f5f9] text-[#475569] ring-[#e2e8f0]",
        className,
      ].join(" ")}
    >
      <span
        className={[
          "h-2 w-2 rounded-full",
          paid ? "bg-emerald-500" : "bg-[#94a3b8]",
        ].join(" ")}
        aria-hidden
      />
      {t("home.planLabel")}: {accountStatusLabel(status, t)}
    </span>
  );
};

export default AccountStatusBadge;
